var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState } from 'react';
import { Dropdown, Menu } from 'antd';
import { CameraOutlined, DownOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { CameraCaptureModal } from './CameraCaptureModal';
export var ConfirmWithPictureButton = function (_a) {
    var buildFileName = _a.buildFileName, onConfirmWithPhotos = _a.onConfirmWithPhotos, onConfirm = _a.onConfirm, _b = _a.disabled, disabled = _b === void 0 ? false : _b, _c = _a.loading, loading = _c === void 0 ? false : _c, confirmWithPictureText = _a.confirmWithPictureText, confirmText = _a.confirmText;
    var t = useTranslation().t;
    var _d = useState(false), isCameraVisible = _d[0], setIsCameraVisible = _d[1];
    var pictureLabel = confirmWithPictureText !== null && confirmWithPictureText !== void 0 ? confirmWithPictureText : t('Confirm with Picture');
    var confirmLabel = confirmText !== null && confirmText !== void 0 ? confirmText : t('Confirm');
    var menu = (_jsx(Menu, { children: _jsx(Menu.Item, __assign({ onClick: onConfirm, disabled: disabled }, { children: confirmLabel }), 'confirm') }, void 0));
    return (_jsxs(_Fragment, { children: [_jsxs(Dropdown.Button, __assign({ type: 'primary', disabled: disabled, loading: loading, icon: _jsx(DownOutlined, {}, void 0), overlay: menu, className: 'w-auto', onClick: function () { return setIsCameraVisible(true); } }, { children: [_jsx(CameraOutlined, {}, void 0), pictureLabel] }), void 0), _jsx(CameraCaptureModal, { visible: isCameraVisible, buildFileName: buildFileName, onCancel: function () { return setIsCameraVisible(false); }, onConfirm: function (files) {
                    setIsCameraVisible(false);
                    onConfirmWithPhotos(files);
                }, confirmText: t('Confirm') }, void 0)] }, void 0));
};
export default ConfirmWithPictureButton;
